import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DeviceClockService } from './device-clock.service';

/**
 * Reads the `Date` header of every backend response to learn the server clock. It runs on the OIDC
 * discovery/jwks/token calls too (they go through HttpClient), so the drift is known even when the
 * session never manages to start.
 */
@Injectable()
export class ServerClockInterceptor implements HttpInterceptor {
  private readonly deviceClock = inject(DeviceClockService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          this.deviceClock.registerServerDate(event.headers.get('Date'));
        }
      })
    );
  }
}
